<template>
    <div>
        <div v-if="!nolabel" class="position-static">
            <b-form-group id="fieldset-datetimepicker" boundary="viewport" v-bind="$attrs" class="position-static">
                <template v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
                <div v-if="isAllowEdit && !isUpdatable" class="position-static">
                    <b-input-group class="position-static">
                        <b-input-group-prepend class="position-static">
                            <b-form-datepicker
                                boundary="viewport"
                                v-model="inputModelDate"
                                button-only
                                locale="en-US"
                                aria-controls="input-datepicker"
                                size="sm"
                                class="bg-transparent boundary-datepicker"
                                @input="setDate"
                                :min="minDate"
                                :max="maxDate"
                            ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                            id="example-input"
                            v-model="inputModelStr"
                            type="text"
                            placeholder="dd/MM/yyyy"
                            autocomplete="off"
                            size="sm"
                            v-maska
                            data-maska="##/##/####"
                            @input="setDateStr"
                        ></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-name-live-feedback" :state="state">
                        {{ errorMessage }}
                    </b-form-invalid-feedback>
                </div>
                <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                    <span>{{ inputModel != null && inputModel != "" ? inputModel : "-" | moment('DD-MMM-YYYY')}}</span>
                    <span class="float-right"><a v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
                </div>
                <div v-else>
                    {{ inputModel | moment('DD-MMM-YYYY') }}
                </div>
            </b-form-group>
        </div>
        <div v-else class="position-static">
            <div v-if="isAllowEdit && !isUpdatable" class="position-static" style="position:static">
                <b-input-group class="position-static" style="position:static">
                    <b-input-group-prepend class="position-static" style="position:static">
                        <b-form-datepicker
                            boundary="viewport"
                            v-model="inputModelDate"
                            button-only
                            locale="en-US"
                            aria-controls="input-datepicker"
                            size="sm"
                            class="bg-transparent boundary-datepicker position-static" style="position:static"
                            @input="setDate"
                            :min="minDate"
                            :max="maxDate"
                        ></b-form-datepicker>
                    </b-input-group-prepend>
                    <b-form-input
                        id="example-input"
                        v-model="inputModelStr"
                        type="text"
                        placeholder="dd/MM/yyyy"
                        autocomplete="off"
                        size="sm"
                        v-maska data-maska="##/##/####"
                        @input="setDateStr"
                    ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback id="input-name-live-feedback" :state="state">
                    {{ errorMessage }}
                </b-form-invalid-feedback>
            </div>
            <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                <span>{{ inputModel != null && inputModel != "" ? inputModel : "-" | moment('DD-MMM-YYYY')}}</span>
                <span class="float-right"><a v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
            </div>
            <div v-else>
                    {{ inputModel | moment('DD-MMM-YYYY') }}
            </div>
        </div>
        <b-popover :show.sync="popoverShow" :target="'popover-button-sync-' + groupId" :title="label" placement="bottomleft">
            <b-input-group class="mb-3 position-static" style="position:static">
                    <b-input-group-prepend class="position-static" style="position:static">
                        <b-form-datepicker
                            boundary="viewport"
                            v-model="inputPopoverModelDate"
                            button-only
                            locale="en-US"
                            aria-controls="input-datepicker"
                            size="sm"
                            class="bg-transparent boundary-datepicker position-static" style="position:static"
                            @input="setPopoverDate"
                            :min="minDate"
                            :max="maxDate"
                        ></b-form-datepicker>
                    </b-input-group-prepend>
                    <b-form-input
                        id="example-input"
                        v-model="inputPopoverModelStr"
                        type="text"
                        placeholder="dd/MM/yyyy"
                        autocomplete="off"
                        size="sm"
                        v-maska data-maska="##/##/####"
                        @input="setPopoverDateStr"
                    ></b-form-input>
                </b-input-group>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button @click="popoverShow = false" size="sm" class="btn-default-white">Cancel</b-button>
                <b-button @click="setPopoverDateTime" size="sm" class="btn-default ml-2">Save</b-button>
            </div>
        </b-popover>
    </div>
</template>
<style lang="scss" scoped>
    ::v-deep.popover.b-popover {
        overflow-x: unset;
    }
    ::v-deep.btn.btn-secondary, ::v-deep.btn.btn-secondary:active, ::v-deep.btn.btn-secondary:hover {
        /*background-color: transparent !important;*/
    }
    ::v-deep.form-control:disabled, .form-control[readonly] {
        background-color: transparent !important;
    }
    ::v-deep::placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep:-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep::-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }
</style>
<script>
import moment from 'moment';
import { vMaska } from 'maska';

export default {
    props: ["model", "id", "errorMessage", "state", "suffix", "prefix", "isEditable", "isUpdatable", "change", "nolabel", "label", "isRequired","min","max", "nolabel", "returnValue","notUseDefaultValue"],
    directives: { maska: vMaska },
    data() {
        return {
            labelStr: this.label,
            inputModel:this.model,
            inputModelDate: '',
            inputModelTime: '',
            inputModelStr: '',
            prefixExist: (this.prefix ? true : false),
            suffixExist: (this.suffix ? true : false),
            value:'',
            minDate:this.min,
            maxDate:this.max,
            groupId : "fieldset-datetimepicker-" + this.id,
            inputPopoverModelDate: '',
            inputPopoverModelTime: '',
            inputPopoverModelStr: '',
            popoverInputModel:this.model,
            popoverShow: false,
        }
    }, 
    methods: {
        setDate() {
            let inputModelDate = '1970-01-01';
            if (this.inputModelDate != '') {
                inputModelDate = this.inputModelDate;
            }
            this.inputModel = inputModelDate;
            let date = new Date(this.inputModel);
            if (date) {
                this.inputModelStr = moment(date).format('DD/MM/YYYY');
            }
            this.$emit('update:model', this.inputModel);
            this.$emit('change')
        },
        setDateStr() {
            if (this.inputModelStr != null && this.inputModelStr != '') {
                if (this.inputModelStr.length >= 10) {
                    var dateParts = this.inputModelStr.split("/");
                    let date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); 
                    
                    if (date != 'Invalid Date') {
                        this.inputModelDate = moment(date).format('YYYY-MM-DD');
                        this.inputModel = this.inputModelDate;
                        console.log(this.inputModel);
                        this.$emit('update:model', this.inputModel);
                        // this.$emit('change');
                    } else {
                        this.inputModelStr = date;
                    }
                }
            }
        },
        setPopoverDateStr() {
            if (this.inputPopoverModelStr != null && this.inputPopoverModelStr != '') {
                if (this.inputPopoverModelStr.length >= 10) {
                    var dateParts = this.inputPopoverModelStr.split("/");
                    let date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); 
                    
                    if (date != 'Invalid Date') {
                        this.inputPopoverModelDate = moment(date).format('YYYY-MM-DD');
                        this.inputPopoverModel = this.inputPopoverModelDate;
                    } else {
                        this.inputPopoverModelStr = date;
                    }
                }
            }
        },
        setLabel(newValue) {
            if (newValue == null) return;
            let date = new Date(newValue);
            if (date != 'Invalid Date') {
                this.inputModelStr = moment(date).format('DD/MM/YYYY');
                this.inputModelDate = moment(date).format('YYYY-MM-DD');
            }
            this.inputModel = newValue
        },
        setPopoverDate() {
            let inputModelDate = '1970-01-01';
            if (this.inputPopoverModelDate != '') {
                inputModelDate = this.inputPopoverModelDate;
            }
            this.inputPopoverModel = inputModelDate;
            let date = new Date(this.inputPopoverModel);
            if (date) {
                this.inputPopoverModelStr = moment(date).format('DD/MM/YYYY');
            }
        },
        setPopoverDateTime() {
            this.inputModel = this.inputPopoverModel;
            this.$emit('update:model', this.inputModel);
            this.$emit('change', 'SUBMITTED');
            this.isSubmitted = true;
            this.popoverShow = false;
        },
        onPopoverShow() {
            this.isSubmitted = false;
            this.inputPopoverModelStr = moment(this.inputModel).format('DD/MM/YYYY');
            this.inputPopoverModel = this.inputModel;
            this.inputPopoverModelDate = this.inputModel;
            this.popoverShow = true;
        }
    },
    mounted() {
        this.setLabel(this.model);
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        }
    },
    watch: {
        model(newValue,oldValue) {
            let updateByTime = false;
            if (newValue != null && newValue != '') {
                let date = new Date(newValue);
                if (date != 'Invalid Date') {
                    this.inputModelStr = moment(date).format('DD/MM/YYYY');
                }
                this.inputModel = newValue    
            } else if(this.notUseDefaultValue) {
                this.inputModelDate = '';
                this.inputModelStr = '';
                updateByTime = true;
            } else {
                let date = new Date();
                this.inputModelDate = moment(date).format('YYYY-MM-DD');
                this.inputModelStr = moment(date).format('DD/MM/YYYY');
                this.inputModel = this.inputModelDate;
                updateByTime = true;
            }
            if(updateByTime || moment(newValue).format('DD/MM/YYYY')!=moment(oldValue).format('DD/MM/YYYY')){
                //this.$emit('change');
                return;
            }
        },
        returnValue(newValue, oldValue) {
            if (this.isUpdatable && this.isSubmitted) {
                if (newValue) {
                    this.popoverShow = false;
                    this.isSubmitted = false;
                }
            }
        },
        min(newValue) {
            this.minDate = newValue;
        },
        max(newValue) {
            this.maxDate = newValue;
        },
        
    }
}
</script>
<style scoped>
.input-group-text {
    font-size: 0.7rem !important;
}
</style>